// The automation hook points for routines (docs/plans/routines.md). Run commands return `hooks`
// ({ when: start | step | skip | finish | skipRun, routineId, runId, … }); they land here after the group is
// committed. Automations aren't built yet — listeners can subscribe (e.g. "after another routine" triggers).
const listeners = new Set();

export function onRoutineHook(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function runRoutineHooks(hooks = []) {
  for (const h of hooks) for (const fn of listeners) {
    try { fn(h); } catch (e) { console.error('routine hook failed:', e); }
  }
}
